(() => {
  const MANAGER_KEY = "__scrollingFeaturesBarManager";

  if (window[MANAGER_KEY]) {
    window[MANAGER_KEY].refresh();
    return;
  }

  // Aynı sayfada birden fazla bar varsa kodun tekrar başlamasını engeller.
  window[MANAGER_KEY] = { refresh() {} };

  class ScrollingFeaturesBarManager {
    constructor() {
      this.resizeTimer = null;
      this.resizeObserver = null;
      this.observedContainers = new WeakSet();
      // Her bar için son kurulumdaki genişlikler (değişmediyse yeniden kurma).
      this.lastSizes = new WeakMap();

      this.handleResize = this.handleResize.bind(this);
      this.handleSectionLoad = this.handleSectionLoad.bind(this);

      window.addEventListener("resize", this.handleResize, { passive: true });
      document.addEventListener(
        "shopify:section:load",
        this.handleSectionLoad
      );

      if ("ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            const bar = entry.target.closest(
              ".scrolling-features-bar"
            );

            if (bar) {
              this.setupBar(bar);
            }
          });
        });
      }

      this.refresh();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.refresh());
      }

      window.addEventListener(
        "load",
        () => this.refresh(),
        { once: true }
      );
    }

    refresh(root = document) {
      const bars = root.matches?.(".scrolling-features-bar")
        ? [root]
        : root.querySelectorAll(".scrolling-features-bar");

      bars.forEach((bar) => {
        this.setupBar(bar);
      });
    }

    setupBar(bar) {
      const container = bar.querySelector(
        ".features-track-container"
      );

      const track = bar.querySelector(".features-track");

      if (!container || !track) return;

      const groups = Array.from(track.children).filter((child) =>
        child.classList.contains("feature-items")
      );

      if (!groups.length) return;

      const template = groups[0];

      /*
       * Mobilde sayfa kaydırılırken adres çubuğu gizlenip açıldığı için
       * tarayıcı sürekli "resize" tetikler (yalnızca yükseklik değişir).
       * Genişlikler aynıysa hiçbir şeye dokunma; aksi halde animasyon
       * her seferinde sıfırlanıp yazı başa sarıyordu.
       */
      const groupWidthNow = Math.round(template.getBoundingClientRect().width);
      const containerWidthNow = Math.round(container.getBoundingClientRect().width);
      const last = this.lastSizes.get(bar);

      if (
        last &&
        last.group === groupWidthNow &&
        last.container === containerWidthNow &&
        groups.length === last.copies
      ) {
        return;
      }

      // Hesaplama yapılırken animasyonu geçici olarak durdur.
      track.style.animation = "none";

      // Önceki hesaplamada oluşturulan kopyaları temizle.
      groups.slice(1).forEach((group) => group.remove());

      template.removeAttribute("aria-hidden");

      const groupWidth = template.getBoundingClientRect().width;
      const containerWidth = container.getBoundingClientRect().width;

      if (!groupWidth || !containerWidth) {
        track.style.removeProperty("animation");
        return;
      }

      /*
       * Ekranı dolduracak kadar içerik kopyası oluşturur.
       * Bir grup ekrandan çıkarken kalan gruplar ekranı doldurmaya
       * devam eder. Ek kopya geniş masaüstü ekranları korur.
       */
      const requiredCopies = Math.max(
        2,
        Math.ceil(containerWidth / groupWidth) + 2
      );

      for (let index = 1; index < requiredCopies; index += 1) {
        const clone = template.cloneNode(true);

        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      }

      /*
       * Animasyon her zaman tam olarak bir içerik grubunun
       * genişliği kadar ilerler. Böylece başlangıç ve bitiş
       * noktaları kusursuz şekilde eşleşir.
       */
      track.style.setProperty(
        "--marquee-distance",
        `${groupWidth}px`
      );

      track.style.width = `${groupWidth * requiredCopies}px`;

      container.style.height =
        `${template.getBoundingClientRect().height}px`;

      // Yeni ölçülerle animasyonu temiz şekilde yeniden başlat.
      void track.offsetWidth;
      track.style.removeProperty("animation");

      this.lastSizes.set(bar, {
        group: groupWidthNow,
        container: containerWidthNow,
        copies: requiredCopies,
      });

      if (
        this.resizeObserver &&
        !this.observedContainers.has(container)
      ) {
        this.observedContainers.add(container);
        this.resizeObserver.observe(container);
      }
    }

    handleResize() {
      window.clearTimeout(this.resizeTimer);

      this.resizeTimer = window.setTimeout(() => {
        this.refresh();
      }, 150);
    }

    handleSectionLoad(event) {
      this.refresh(event.target);
    }
  }

  const start = () => {
    window[MANAGER_KEY] =
      new ScrollingFeaturesBarManager();
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      { once: true }
    );
  } else {
    start();
  }
})();